module.exports = __webpack_public_path__ + "static/media/discover.80c734ae.svg";